import { Component, Input, OnInit } from '@angular/core';
import { ThemeSimplified } from '@app/shared/helpers/theme';

@Component({
  selector: 'app-smash-theme-tracking',
  templateUrl: './smash-theme-tracking.component.html',
  styleUrls: ['./smash-theme-tracking.component.scss']
})
export class SmashThemeTrackingComponent implements OnInit {

  @Input() trackingMethods: ThemeSimplified['trackingMethods'];

  constructor() { }

  ngOnInit(): void {
  }

}
